let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e0yJk")).then(() => parcelRequire('iIrS6'));